import { redirect } from "@tanstack/react-router";
import axiosInstance from "api/axiosInstance";
import queryClient from "api/queryClient";
import { getMeTenantPermissionsQueryOptions, getMeTenantsQueryOptions } from "api/User/queryOptions";
import { getSessionFromStorage } from "hooks/useSession.ts";

export async function redirectIfTenantAccessRestored(tenantSlug: string): Promise<void> {
    const { token } = getSessionFromStorage();
    if (!token) {
        return;
    }

    axiosInstance.setAuthorization(token);

    let tenant: App.Data.TenantData | undefined;
    try {
        const { user } = await queryClient.fetchQuery({ ...getMeTenantsQueryOptions(), staleTime: 0 });
        tenant = user.tenants?.find(
            (userTenant) => userTenant.slug_name === tenantSlug && userTenant.user_active !== false
        );
    } catch {
        return;
    }

    if (!tenant) {
        return;
    }

    try {
        await queryClient.fetchQuery({ ...getMeTenantPermissionsQueryOptions(tenantSlug), staleTime: 0 });
    } catch {
        return;
    }

    throw redirect({
        to: "/$tenantSlug",
        params: { tenantSlug },
        replace: true,
    });
}
